import { FcpTableConfig } from './fcp-table.component';

export const defaultTableConfig: FcpTableConfig = {
    search: {
        show: true,
        placeholder: 'TEXT_SEARCH'
    },
    loadMore: {
        label: 'LOAD_MORE.PROGRESS_LABEL',
        buttonLabel: 'LOAD_MORE.BUTTON_LABEL'
    }
};
